/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef} from 'react'

/**
 * @public
 */
export const LinkRemovedIcon = forwardRef(function LinkRemovedIcon(
  props: React.SVGProps<SVGSVGElement>,
  ref: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      data-sanity-icon="link-removed"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4243 7.07574C17.9038 6.55531 17.1875 6.31422 16.5 6.31422C15.8125 6.31422 15.0962 6.55531 14.5757 7.07574L12.5757 9.07574L13.4243 9.92427L15.4243 7.92427C15.6849 7.66365 16.078 7.51422 16.5 7.51422C16.922 7.51422 17.3151 7.66365 17.5757 7.92427L17.9983 7.50165L17.5757 7.92427L18.0757 8.42427C18.3363 8.68488 18.4858 9.07799 18.4858 9.5C18.4858 9.92201 18.3363 10.3151 18.0757 10.5757L16.7515 11.9H18.4485L18.9243 11.4243C19.4447 10.9038 19.6858 10.1875 19.6858 9.5C19.6858 8.81253 19.4447 8.09617 18.9243 7.57574L18.5 8L18.9243 7.57574L18.4243 7.07574ZM12.0757 11.4243L12.5515 11.9H14.2485L12.9243 10.5757C12.4038 10.0553 11.6875 9.81421 11 9.81421C10.3125 9.81421 9.59617 10.0553 9.07574 10.5757L7.75147 11.9H9.44853L9.92427 11.4243C10.1849 11.1636 10.578 11.0142 11 11.0142C11.422 11.0142 11.8151 11.1636 12.0757 11.4243ZM7.24853 14.1H5.67654C5.43071 14.5303 5.31421 15.0221 5.31421 15.5C5.31421 16.1875 5.55529 16.9038 6.07573 17.4243L6.4965 17.0035L6.07573 17.4243L6.57573 17.9243C7.09616 18.4447 7.81252 18.6858 8.49999 18.6858C9.18746 18.6858 9.90382 18.4447 10.4243 17.9243L12.4243 15.9243L11.5757 15.0757L9.57573 17.0757C9.31511 17.3363 8.922 17.4858 8.49999 17.4858C8.07798 17.4858 7.68487 17.3363 7.42426 17.0757L6.99999 17.5L7.42425 17.0757L6.92426 16.5757C6.66364 16.3151 6.51421 15.922 6.51421 15.5C6.51421 15.078 6.66365 14.6849 6.92426 14.4243L7.24853 14.1ZM16.2485 14.1H11.7515L12.0757 14.4243C12.5962 14.9447 13.3125 15.1858 14 15.1858C14.6875 15.1858 15.4038 14.9447 15.9243 14.4243L16.2485 14.1ZM2 13.6H23V12.4H2V13.6Z"
        fill="currentColor"
      />
    </svg>
  )
})
